export const CanvaLiterals = {
  PublishLabel: 'Add to Buffer',
  FileType: 'png',
  CanvaFilename: 'canva.png',
}
